import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ENV_TOKEN, EnvInterface} from 'env-config';
import {firstValueFrom} from 'rxjs';
import {AuthValidationService} from 'auth';

@Injectable({providedIn: 'root'})
export class DigitalLicenceService {
  private http = inject(HttpClient);
  private environment = inject(ENV_TOKEN) as EnvInterface;

  private authToken = '';

  constructor(private readonly authValidationService: AuthValidationService) {
    this.authToken = this.authValidationService.readAuthToken()
  }

  async getDigitalProductLicenses(userGuid: string): Promise<any> {
    const url = this.environment.security.tuatara.endpoint;
    const apiKey = this.environment.security.tuatara.apiKey;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
      'Authorization': `Bearer ${this.authToken}`,
    });
    return await firstValueFrom(this.http.get(url + `/account/digital-licences/${userGuid}`, {headers}));
  }
}
